<template>
    <div class="home">
        <div class="home-content-container">
            <div class="home-content-wrapper">
                <transition appear
                    v-on:before-enter="beforeEnterStatementImage"
                    v-on:enter="enterLogoStatementImage">
                    <img class="home-content-container__image" src="@/assets/imgs/home-hi.png" alt="">
                </transition>

                <div class="home-content-container__heading-wrapper">
                    <transition appear
                    v-on:before-enter="beforeEnterStatementText"
                    v-on:enter="enterLogoStatementText">
                        <h2 class="home-content-container__heading">
                            <span class="home-content-container__heading--bold">We are&nbsp;HUNTER:</span>&nbsp;<span class="home-content-container__heading--highlight">A&nbsp;strategic and creative marketing communications partner</span> earning attention and elevating reputation for leading companies and brands around the world across consumer, corporate and B2B audiences.
                        
                          <div style="text-align: left !important;">
                            <!--<a data-v-7231f4b2="" href="https://player.vimeo.com/video/875613080?autoplay=1" target="_blank" style="text-decoration: none;">-->
                            <a data-v-7231f4b2="" href="/news/newswire" style="text-decoration: none;">
                            <span class="modal-link" data-v-7231f4b2="" data-v-48754880=""  style="margin-top: 10px; background-color: rgb(23, 60, 73); color: rgb(255, 255, 255); border: none; padding: 10px 18px; text-transform: uppercase; font-size: 16px; border-radius: 5px; font-family: Flama, Arial, Helvetica, sans-serif;">
                              Read More Here
                            </span>
                          </a>
                        </div>
                          
                        </h2>
                      
                    </transition>
                </div>
              <div >
              <p>&nbsp;</p>
                <transition appear
                v-on:before-enter="beforeEnterStatementText"
                v-on:enter="enterLogoStatementText">
                  <h2 class="home-content-container__heading">
                    <span class="home-content-container__heading--bold">
                      
                    </span>
                  </h2>
                </transition>
              </div>
              
            </div>

            <transition appear
                v-on:before-enter="beforeEnterScrollText"
                v-on:enter="enterScrollText">

                <div class="home-content-container__scroll-tip-container">
                    <router-link class="home-content-container__scroll-link" to="/work">
                        <picture>
                            <source media="(max-width: 1024px)" srcset="/assets/imgs/scroll-mobile.png">
                            <source media="(min-width: 1025px)" srcset="/assets/imgs/scroll-right.png">
                            <img class="home-content-container__scroll-tip-image" src="/assets/imgs/scroll-right.png">
                        </picture>

                        <div class="home-content-container__scroll-tip-text">scroll to navigate</div>
                        <div class="home-content-container__scroll-tip-text--swipe">swipe to navigate</div>
                    </router-link>
                </div>
            </transition>
        </div>

        <video class="home-video" autoplay muted loop playsinline>
            <source src="/assets/vids/Hunter-Website-Intro.mp4" type="video/mp4">
        </video>
    </div>
</template>

<style scoped lang="less">
  /* Modal styles */
  .modal {
  display: none;
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  }

  .modal-content {
  display: block;
  margin: 10% auto;
  width: 60%;
  max-width: 800px;
  background-color: #fefefe;
  padding: 20px;
  border: 1px solid #888;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  }

  /* Link styles */
  .modal-link {
  display: inline-block;
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  text-decoration: none;
  border-radius: 5px;
  }
  
  @import "../less/app.less";
  @import "../less/breakpoints.less";

  .home {
  background-color: #003a4a;
  color: #ffffff;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  position: relative;

  &:after {
            content: "";
            position: absolute;
            height: 100%;
            width: 100%;
            top: 0;
            left: 0;
            z-index: 5;
            background: rgba(0, 58, 74, 0.5);
        }
    }

    .home-content-container {
        box-sizing: border-box;
        margin: 0 auto;
        max-width: 800px;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        z-index: 10;

        .home-content-wrapper {
            // Extra room so the longer headline doesn't overlap the scroll tip
            margin-bottom: 16%;
            position: relative;

            @media @breakpoint__tablet--medium {
                margin-bottom: 22%;
            }

            @media @breakpoint__mobile--large {
                margin-bottom: 10%;
            }
        }

        @media @breakpoint__mobile--large {
            padding: 0 12%;
        }
        
        @media @breakpoint__tablet--medium {
            padding: 0 10%;
        }

        .home-content-container__image {
            box-sizing: border-box;
            display: inline-block;
            padding: 0;
            vertical-align: top;
            width: 30%;

            @media @breakpoint__mobile--large {
                display: block;
                margin-bottom: 20px;
                width: 50%;
            }
        }

        .home-content-container__heading-wrapper {
            display: inline-block;
            overflow: hidden;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: 70%;

            @media @breakpoint__mobile--large {
                display: block;
                position: relative;
                transform: translateY(0);
                width: 100%;
            }

            .home-content-container__heading {
                box-sizing: content-box;
                font-size: 28px;
                font-weight: 400;
                letter-spacing: 1px;
                line-height: 165%;
                margin: 0;
                padding-left: 10%;
                
                @media @breakpoint__tablet--medium {
                    font-size: 3vw;
                }

                @media @breakpoint__mobile--large {
                    padding-left: 0;
                    font-size: 4.8vw;
                }

                .home-content-container__heading--bold {
                    font-family: Flama-Bold, Arial, Helvetica, sans-serif;
                    font-weight: 700;
                }

                .home-content-container__heading--highlight {
                    color: #e40046;
                }
            }
        }
        
        
        .home-content-container__heading-wrapper {
            display: inline-block;
            overflow: hidden;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: 70%;

            @media @breakpoint__mobile--large {
                display: block;
                position: relative;
                transform: translateY(0);
                width: 100%;
            }

            .home-content-container__heading {
                box-sizing: content-box;
                font-size: 28px;
                font-weight: 400;
                letter-spacing: 1px;
                line-height: 165%;
                margin: 0;
                padding-left: 10%;
                
                @media @breakpoint__tablet--medium {
                    font-size: 3vw;
                }

                @media @breakpoint__mobile--large {
                    padding-left: 0;
                    font-size: 4.8vw;
                }

                .home-content-container__heading--bold {
                    font-family: Flama-Bold, Arial, Helvetica, sans-serif;
                    font-weight: 700;
                }

                .home-content-container__heading--highlight {
                    color: #e40046;
                }
            }
        }
        
        
        
       
        .home-content-container__heading-wrapper {
            display: inline-block;
            overflow: hidden;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: 70%;

            @media @breakpoint__mobile--large {
                display: block;
                position: relative;
                transform: translateY(0);
                width: 100%;
            }

            .home-content-container__heading {
                box-sizing: content-box;
                font-size: 28px;
                font-weight: 400;
                letter-spacing: 1px;
                line-height: 165%;
                margin: 0;
                padding-left: 10%;
                
                @media @breakpoint__tablet--medium {
                    font-size: 3vw;
                }

                @media @breakpoint__mobile--large {
                    padding-left: 0;
                    font-size: 4.8vw;
                }

                .home-content-container__heading--bold {
                    font-family: Flama-Bold, Arial, Helvetica, sans-serif;
                    font-weight: 700;
                }

                .home-content-container__heading--highlight {
                    color: #e40046;
                }
            }
        }
       
       
       
       
       
       
       
       
       
       
       
       
       
       
       
       
       
       
        
        
        
    }

    .home-content-container__scroll-tip-container {
        text-align: center;

        .home-content-container__scroll-link {
            color: #ffffff;
            text-decoration: none;
        }

        .home-content-container__scroll-tip-image {
            margin: 0 0 10px 10px;
        }

        .home-content-container__scroll-tip-text {
            font-size: 16px;

            @media @breakpoint__tablet--large {
                display: none;
            }
        }

        .home-content-container__scroll-tip-text--swipe {
            .home-content-container__scroll-tip-text();
            display: none;
            
            @media @breakpoint__tablet--large {
                display: block;
            }
        }
    }

    .home-video {
        height: auto;
        left: 50%;
        min-height: 100%; 
        min-width: 100%; 
        position: absolute;
        top: 50%;
        transform: translate(-50%,-50%);
        width: auto;
    }
</style>

<script>
    export default {
        name: "Home",
        created : function()
        {
            var vm = this;
            var testIfDataLoaded = setInterval(function()
            {
                if (!vm.isObjectEmpty(vm.$parent.modelSeo))
                {
                    clearInterval(testIfDataLoaded);
                }
            }, 500);
        },
        mounted: function()
        {
            TweenMax.to(".header__logo-sub-title-container", 0.2, {width: 0});
        },
        methods: {
            beforeEnterStatementImage : function(el)
            {
                el.style.opacity = 0;
            },
            enterLogoStatementImage : function(el, done)
            {
                TweenMax.fromTo(el, 0.5, {transform: "translateX(300%)"}, {opacity: 1, transform: "translateX(0)", delay: 0.5, onComplete: done});
            },
            beforeEnterStatementText : function(el)
            {
                el.style.transform =  "translateX(-100%)";
            },
            enterLogoStatementText : function(el, done)
            {
                TweenMax.to(el, 0.4, {opacity: 1, transform: "translateX(0)", delay: 0.9, onComplete: done});
            },
            beforeEnterScrollText : function(el)
            {
                el.style.opacity =  0;
                el.style.transform =  "translateY(30px)";
            },
            enterScrollText : function(el, done)
            {
                TweenMax.to(el, 0.6, {opacity: 1, transform: "translateY(0)", delay: 1.1, onComplete: done});
            }
        }
    };
</script>
